import { render, staticRenderFns } from "./SpecsSingle.vue?vue&type=template&id=a2e419fc&scoped=true&"
import script from "./SpecsSingle.vue?vue&type=script&lang=js&"
export * from "./SpecsSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e419fc",
  null
  
)

export default component.exports